import { render, staticRenderFns } from "./Asteroid2.vue?vue&type=template&id=3b7b61c2&scoped=true&"
import script from "./Asteroid2.vue?vue&type=script&lang=js&"
export * from "./Asteroid2.vue?vue&type=script&lang=js&"
import style0 from "./Asteroid2.vue?vue&type=style&index=0&id=3b7b61c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7b61c2",
  null
  
)

export default component.exports